import React from 'react'
import {makeStyles } from '@material-ui/core';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import PremiumSermonIcon from '@material-ui/icons/InsertDriveFileSharp';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import FolderIcon from '@material-ui/icons/Folder';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import BallotIcon from '@material-ui/icons/Ballot';
import LinkIcon from '@material-ui/icons/Link';
import classNames from 'classnames';
import VimeoLogo from '../../../../resources/vimeo.png';
import SoundCloudBlueLogo from '../../../../resources/soundCloudBlue.png';
import YouTubeBlueLogo from '../../../../resources/youtubeBlue.png';
import ArchiveIcon from '@material-ui/icons/Archive';
import { LibraryItemType } from '../../../../entities/LibraryItemType';
import { LinkAssetType } from '../../../../entities/LinkAssetType';
import { UserAgent } from '../../../../utilities/UserAgent';

const useStyles = makeStyles((theme) => ({
    icon: {
        color: "rgb(66, 133, 244)",
        marginRight: 8,
    },
    iconFolder: {
        color: "rgb(143, 143, 143)",
        marginRight: 8,
    },
    iconSeries: {
        marginRight: 8,
        color: "rgb(118, 39, 187)",
    },
    iconAsset: {
        color: "rgb(66, 133, 244)",
        marginRight: 8,
    },
    iconLinkAsset: {
        verticalAlign: "sub"
    },
    iconVimeo: {
        marginRight: 8,
        backgroundColor: "rgb(66, 133, 244)",
        borderRadius: 14,
    },
    soundCloudIcon: {
        border: "1px solid rgb(66, 133, 244)",
        borderRadius: 20,
        "& img": {
            width: 24,
            height: 24
        }
    },
}));

interface Props{
    itemType:LibraryItemType;
    isTemplate: boolean;
    linkType?: LinkAssetType
}

export function LibraryItemIcon (props:Props) {
    const {itemType, isTemplate, linkType} = props;
    const isMobile = UserAgent.mobile()
    const classes = useStyles();

    switch (itemType) {
        case(LibraryItemType.BuilderAsset):
            if(!isTemplate){
                return <InsertDriveFileIcon className={classes.icon} />
            } else {
                return <BallotIcon className={classes.icon} />
            }
        case(LibraryItemType.Folder):
            return <FolderIcon className={classes.iconFolder} />
        case(LibraryItemType.LinkAsset):
            if(linkType === LinkAssetType.SoundCloud){
                return(
                    <ListItemIcon className={classNames(classes.iconAsset, classes.soundCloudIcon, !isMobile && classes.iconLinkAsset)}>
                        <img alt="SoundCloud" src={SoundCloudBlueLogo} />
                    </ListItemIcon>
                )
            } else if(linkType === LinkAssetType.Vimeo){
                return(
                    <ListItemIcon className={classNames(classes.iconAsset, classes.iconVimeo, !isMobile && classes.iconLinkAsset)}>
                        <img alt="Vimeo" src={VimeoLogo} />
                    </ListItemIcon>
                )
            } else if(linkType === LinkAssetType.YouTube){
                return (
                    <ListItemIcon className={classNames(classes.iconAsset, !isMobile && classes.iconLinkAsset)}>
                        <img alt="Youtube" style={{ width: "24px", height: "24px" }} src={YouTubeBlueLogo} />
                    </ListItemIcon>
                )
            } else {
                return <LinkIcon className={classNames(classes.iconAsset, !isMobile && classes.iconLinkAsset)} />;
            }
        case(LibraryItemType.PremiumSermon):
            return <PremiumSermonIcon className={classes.iconFolder} />;
        case(LibraryItemType.PremiumSermonSeries):
            return <LibraryBooksIcon className={classes.iconSeries} />;
        case(LibraryItemType.SermonSeries):
            return <LibraryBooksIcon className={classes.iconSeries} />;
        case(LibraryItemType.None):
            return null;
        case(LibraryItemType.FileAsset):
            return <ArchiveIcon className={classes.iconAsset} />;
    }
}